var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { consumerTheme, fontWeights, spacing, colors as syfColors, fontSizes as syfFontSizes } from 'syf-component-library/defaultTheme';
export var statusColors = {
    PENDING: {
        background: '#e3f2f8',
        text: '#34657f',
        icon: '#34657f'
    },
    POSTED: {
        background: '#e7f6e3',
        text: '#2b5d1d',
        icon: '#3e8529'
    },
    CANCELED: {
        background: '#fcf4f3',
        text: '#9E2A20',
        icon: '#9E2A20'
    },
    REJECTED: {
        background: '#f7f7f7',
        text: 'black',
        icon: 'black'
    },
    PROCESSING: {
        background: '#F7F7F7',
        text: '#636363',
        icon: '#636363'
    },
    SCHEDULED: {
        background: '#E3F2F8',
        text: '#34657F',
        icon: '#34657F'
    }
};
var colors = __assign(__assign({}, syfColors), { trueBlack: '#000000', alabaster: '#fafafa', nero: '#232323' });
var fontSizes = __assign({ regular: 14 }, syfFontSizes);
export { colors, fontSizes, fontWeights, spacing };
export default consumerTheme;
//# sourceMappingURL=theme.js.map